import { useQuery } from '@apollo/client';
import { GET_RETAIL_STORES } from '@/graphql/queries';

const useRetailStores = () => {
  const { data, loading, error } = useQuery(GET_RETAIL_STORES, {
    fetchPolicy: 'cache-first',
  });

  const stores = data?.getRetailStores || [];

  return {
    stores,
    loading,
    error,
  };
};

export default useRetailStores;
